// releaseNote.ts
import type { ReleaseNote } from '../types/releaseNote';

/**
 * The note shown once per merchant, on the first dashboard load after the
 * version below changes. `useReleaseNotesStore` persists the last seen version
 * in localStorage, so bumping `version` is what re-opens it for everyone.
 *
 * 🔴 ANNOUNCE ONLY WHAT A MERCHANT CAN ACTUALLY GO AND FIND TODAY. Each line
 * below names a real surface, verified live on production before it was
 * written: Settings → Service level (`/settings`, ServicePreferenceSection),
 * Settings → Pricing plan (`/settings/pricing-plan`), and Smart Paste on the
 * add- and edit-order screens. A note that promises a screen the merchant
 * cannot reach costs more trust than saying nothing at all.
 *
 * ⚠️ Keep the voice: warm, non-technical, second person, and Iraqi colloquial
 * in Arabic — matching the 1.0.8 note, which is the voice merchants already
 * know. This is not a changelog; internal names (Boxy Select's resolution
 * ladder, province rules as "overrides", tiers, carriers) do not belong here.
 * The merchant wants to know what they can now do, and where.
 */
export const CURRENT_RELEASE_NOTE: ReleaseNote = {
  type: 'web',
  version: '1.1.0',
  note: {
    ar: `🚀 شنو الجديد بلوحة التاجر

🎯 اختار مستوى الخدمة لطلباتك — هسه تقدر تحدد الخدمة اللي تنشحن بيها طلباتك، وتخلي وحدة افتراضية لكل الطلبات. وإذا محافظة معينة تحتاج خدمة مختلفة، تكدر تضيف لها قاعدة خاصة. تلگاها بالإعدادات، قسم "مستوى الخدمة".

💵 السعر يبين قبل ما تأكد الطلب — سعر التوصيل يظهر لك وأنت تنشئ الطلب، حتى تعرف كلفة الطلب قبل ما ترسله.

📊 خطة التسعير مالتك — هسه تكدر تشوف السعر اللي تدفعه لكل طلب وشنو الشي اللي يغيّره. تلگاها بالإعدادات، قسم "خطة التسعير".

✨ أنشئ طلب من رسالة — الصق رسالة الزبون من واتساب أو انستغرام، وإحنا نملّي لك الاستمارة. راجعها وأكمل. تلگاها لما تضيف طلب جديد أو تعدّل طلب.

🔧 تحسينات عامة وإصلاح مشاكل لتجربة أسلس.

شكراً لاستخدامك بوكسي 💛`,
    en: `🚀 **What's New on Merchant Dashboard**

🎯 **Choose the service your orders ship on** — Pick a default service for all your orders, and add a rule for any province that needs a different one. Find it in Settings → Service level.

💵 **See the price before you confirm** — The delivery price is shown while you create the order, so you know what it costs before you send it.

📊 **Your pricing plan** — See the rate you pay per order and what changes it, in Settings → Pricing plan.

✨ **Create an order from a message** — Paste your customer's WhatsApp or Instagram message and we'll fill in the form for you. Check it and carry on. Look for it when you add a new order or edit one.

🔧 General improvements and fixes for a smoother experience.

Thanks for using Boxy 💛`,
  },
  created_at: '2026-09-01T00:00:00+00:00',
};
